let currentIndex = 0;

function moveSlide(direction) {
  const items = document.querySelectorAll(".product");
  const totalItems = items.length;

  currentIndex += direction;
  if (currentIndex < 0) {
    currentIndex = totalItems - 1;
  } else if (currentIndex >= totalItems) {
    currentIndex = 0;
  }
  const offset = -currentIndex * 108.3;

  items.forEach((elem) => (elem.style.transform = `translateX(${offset}%)`));
}
function productRecommended() {
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(".product-recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          const moveBack =
            productRecommendationsSection.querySelector(".moveBack");
          const moveFrom =
            productRecommendationsSection.querySelector(".moveFrom");

          moveBack.addEventListener("click", () => {
            moveSlide(-1);
          });
          moveFrom.addEventListener("click", () => {
            moveSlide(1);
          });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector(
    ".product-recommendations"
  );
  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: "0px 0px 200px 0px",
  });

  observer.observe(productRecommendationsSection);
}
function changeSize(element) {
  const lstOptions = element.querySelectorAll(".size-option-js");
  const sizeSelect = element.querySelector(".single-option-selector");
  const sizeSelectAlt = element.querySelector(".product-form__variants");
  const sizeValue = element.querySelector("#size-value-js");
  const buttonAtc = element.querySelector("[data-add-to-cart]");

  lstOptions.forEach((option) => {
    option.addEventListener("click", (e) => {
      let target = e.target;
      lstOptions.forEach((option) =>
        option.classList.remove("size-container__option--selected")
      );

      const selectedOption = Array.from(sizeSelect.options).find(
        (opt) => opt.value === e.target.dataset.value
      );
      if (selectedOption) {
        sizeSelect.selectedIndex = selectedOption.index;
        sizeSelectAlt.selectedIndex = selectedOption.index;

        const eventChange = new Event("change");

        sizeSelect.dispatchEvent(eventChange);
        sizeSelectAlt.dispatchEvent(eventChange);

        target.classList.add("size-container__option--selected");

        sizeValue.textContent = ` ${target.dataset.value}`;

        if (target.classList.contains("size-container__option--disable")) {
          buttonAtc.disabled = true;
          buttonAtc.firstElementChild.innerText = window.variantStrings.soldOut;
        } else {
          buttonAtc.disabled = false;
          buttonAtc.firstElementChild.innerText =
          window.variantStrings.addToCart;
        }
      }
    });

    /* Synchronize the PDP when the selection in the sticky area changes */
    sizeSelect.addEventListener("change", () => {
      const selectedValue = sizeSelect.options[sizeSelect.selectedIndex].value;
      const selectedOptionPDP = Array.from(
        element.querySelectorAll(
          `.size-container__option[data-value="${selectedValue}"]`
        )
      );
      element.querySelectorAll(".size-container__option").forEach((option) => {
        option.classList.remove("size-container__option--selected");
      });
      if (selectedOptionPDP.length) {
        selectedOptionPDP.forEach((elementOption) => {
          elementOption.classList.add("size-container__option--selected");
        });
      }
    });
  });
}

function createMessaging() {
  let messagingWidget = document.querySelector("#afterpay-messaging-widget");
  if (messagingWidget) {
    messagingWidget.innerHTML = "";

    new AfterPay.Widgets.Placement({
      target: "#afterpay-messaging-widget",
      locale: "en-US",
      context: "PRODUCT_PAGE",
      publicKey: "48dea4f6-68d6-442a-b5c3-ad739a37f4c5",
      attributes: {
        currency: "USD",
        amountSelector: ".price__pricing-group > .price__regular .price-item",
        min: "35.00",
        max: "1000.00",
        is_eligible: "true",
        size: "xs",
        logoType: "compact-badge",
        styles: {
          textAlign: "left",
          fontFamily: "sans-serif",
          textColor: "Black",
        },
      },
    });
  }
}

function openModal(element) {
  const collectionModal = element.querySelector(".collection_modal");
  const pageOverload = document.querySelector("#pageOverload");

  pageOverload.classList.add("open");
  collectionModal.classList.add("open");
  document.body.classList.add("modal_open");
}

function closeModal(element) {
  const collectionModal = element.querySelector(".collection_modal");
  const pageOverload = document.querySelector("#pageOverload");

  pageOverload.classList.remove("open");
  collectionModal.classList.remove("open");
  document.body.classList.remove("modal_open");
}

function wishlistFunctions() {
  let wishlistButtonAdd = document.querySelectorAll(".wishlist-btn-add");
  let wishlistButtonRemove = document.querySelectorAll(".wishlist-btn-remove");
  let infoElement = document.querySelector(".collection_modal");

  function swymCallbackFn() {
    if (wishlistButtonAdd || wishlistButtonRemove) {
      _swat.fetchWrtEventTypeET(fetchCallbackFn, 4);
      // fetching all wishlist events
    }
  }

  function fetchCallbackFn(products) {
    let activeProductId = Number(infoElement.getAttribute("data-product-id"));
    let activeVariantId = Number(infoElement.getAttribute("data-variant-id"));
    let activeProductUrl = `${window.location.origin}${infoElement.getAttribute(
      "data-product-url"
    )}`;
    let isInWishlist = products.find(function (p) {
      return p.empi == activeProductId && p.epi == activeVariantId;
    });
    if (isInWishlist) {
      wishlistButtonRemove.forEach((data) => data.classList.add("show"));
      wishlistButtonAdd.forEach((data) => data.classList.remove("show"));
    } else {
      wishlistButtonRemove.forEach((data) => data.classList.remove("show"));
      wishlistButtonAdd.forEach((data) => data.classList.add("show"));
    }

    SwymPageData.et = 4;
    SwymPageData.du = activeProductUrl;
    SwymPageData.epi = activeVariantId;
    SwymPageData.empi = activeProductId;
    wishlistButtonAdd.forEach((data) =>
      data.addEventListener("click", function (e) {
        if (SwymPageData) {
          _swat.addToWishList(SwymPageData, function (e) {
            wishlistButtonRemove.forEach((data) => data.classList.add("show"));
            wishlistButtonAdd.forEach((data) => data.classList.remove("show"));
          });
        }
      })
    );

    wishlistButtonRemove.forEach((data) =>
      data.addEventListener("click", function (e) {
        if (SwymPageData) {
          _swat.removeFromWishList(SwymPageData, function (e) {
            wishlistButtonRemove.forEach((data) =>
              data.classList.remove("show")
            );
            wishlistButtonAdd.forEach((data) => data.classList.add("show"));
          });
        }
      })
    );
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);
}

function changeSwatchSelected(element) {
  let allSwatches = document.querySelectorAll(".swatch-container .swatch");

  allSwatches.forEach((data) => {
    data.classList.remove("selected");
  });

  element.classList.add("selected");
}

function setEvents(elementDom) {
  const swatchColorElement = elementDom.querySelectorAll(
    ".swatch-container .swatch"
  );
  const closeElement = elementDom.querySelectorAll(".collection_modal__close");
  const pageOverload = document.querySelector("#pageOverload");
  const addToCart = document.querySelector("[data-product-form]");

  pageOverload.addEventListener("click", () => {
    closeModal(elementDom);
  });

  addToCart.addEventListener("submit", () => {
    setTimeout(() => {
      closeModal(elementDom);
    }, 1000);
  });

  swatchColorElement.forEach((element) => {
    element.addEventListener("click", () => {
      let handleProduct = element.getAttribute("data-handle-product");
      requestSection(handleProduct);
      changeSwatchSelected(element);
    });
  });

  closeElement.forEach((element) => {
    element.addEventListener("click", () => {
      closeModal(elementDom);
    });
  });
}

function initReviews() {
  if(yotpoWidgetsContainer) yotpoWidgetsContainer.initWidgets();
  if(yotpo) yotpo.initWidgets();
}

function renderModal(text, type) {
  const modal = document.querySelector("#modalAtc");
  if (type == 1) {
    modal.innerHTML = text;

    modal.classList.add("open");

    wishlistFunctions();
    changeSize(modal);
    setEvents(modal);
    createMessaging();
    setTimeout(() => {
      openModal(modal);
    }, 500);
  }

  if (type == 2) {
    const html = document.createElement("div");
    html.innerHTML = text;

    let wrapper = modal.querySelector("#shopify-section-modal");
    let swatchContainer = modal.querySelector(".swatch-container");
    let wrapperNew = html.querySelector("#shopify-section-modal");
    let swatchHtmlContainer = html.querySelector(".swatch-container");

    swatchHtmlContainer.innerHTML = swatchContainer.innerHTML;
    html.querySelector(".collection_modal").classList.add("open");

    wrapper.innerHTML = wrapperNew.innerHTML;

    wishlistFunctions();
    changeSize(modal);
    createMessaging();
    setEvents(modal);
  }

  productRecommended();
  initReviews();
}

function requestSection(handle) {
  fetch(`/products/${handle}?section_id=modal`)
    .then((response) => response.text())
    .then((text) => {
      renderModal(text, 2);
    });
}

function requestProductSection() {
  let buttonAtc = document.querySelectorAll(".modal__button_atc");
  buttonAtc.forEach((element) => {
    element.onclick = () => {
      let handle = element.getAttribute("data-product-handle");
      fetch(`/products/${handle}?section_id=modal`)
        .then((response) => response.text())
        .then((text) => {
          renderModal(text, 1);
        });
    };
  });
}

function renderButtonOpen() {
  setTimeout(() => {
    let elements = document.querySelectorAll(".nosto--item");
    elements.forEach((elem) => {
      let isButton = elem.querySelector(".collection_modal_item__button");
      let isButtonComing = elem.querySelector(".collection_modal_item__button");

      if (isButton || isButtonComing) return false;

      let link = document.createElement("button");
      if(!elem.getAttribute('data-url')) return false;
      let handle =
        elem.getAttribute('data-url').split(
          "products/"
        ); 
      link.innerHTML = `<svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.03125 9.60938C5.86458 10.4167 6.85417 10.8203 8 10.8203C9.14583 10.8203 10.1224 10.4167 10.9297 9.60938C11.763 8.80208 12.1797 7.82552 12.1797 6.67969H10.5C10.5 7.35677 10.2526 7.94271 9.75781 8.4375C9.26302 8.93229 8.67708 9.17969 8 9.17969C7.32292 9.17969 6.73698 8.93229 6.24219 8.4375C5.7474 7.94271 5.5 7.35677 5.5 6.67969H3.82031C3.82031 7.82552 4.22396 8.80208 5.03125 9.60938ZM9.75781 3.24219C9.26302 2.7474 8.67708 2.5 8 2.5C7.32292 2.5 6.73698 2.7474 6.24219 3.24219C5.7474 3.73698 5.5 4.32292 5.5 5H10.5C10.5 4.32292 10.2526 3.73698 9.75781 3.24219ZM13.8203 5C14.263 5 14.6536 5.16927 14.9922 5.50781C15.3307 5.84635 15.5 6.23698 15.5 6.67969V16.6797C15.5 17.1224 15.3307 17.513 14.9922 17.8516C14.6536 18.1641 14.263 18.3203 13.8203 18.3203H2.17969C1.73698 18.3203 1.34635 18.1641 1.00781 17.8516C0.669271 17.513 0.5 17.1224 0.5 16.6797V6.67969C0.5 6.23698 0.669271 5.84635 1.00781 5.50781C1.34635 5.16927 1.73698 5 2.17969 5H3.82031C3.82031 3.85417 4.22396 2.8776 5.03125 2.07031C5.86458 1.23698 6.85417 0.820312 8 0.820312C9.14583 0.820312 10.1224 1.23698 10.9297 2.07031C11.763 2.8776 12.1797 3.85417 12.1797 5H13.8203Z" fill="white"/>
          </svg>`;
      link.setAttribute("data-product-handle", handle[1]);
      link.classList.add("collection_modal_item__button");
      link.classList.add("modal__button_atc");

      elem.firstElementChild.appendChild(link);
    });

    requestProductSection();
  }, 2500);
}

function renderButtonCommingSoon() {
  setTimeout(() => {
    const elements = Array.from(document.querySelectorAll(".ns-product, .product-card-wrapper"));
    if (!elements.length) return;

    const productVariantElements = Array.from(document.querySelectorAll(".collection__product-variant"));
    if (!productVariantElements.length) return;

    const productVariants = productVariantElements
      .map((variantElement) => {
        try {
          const variantData = JSON.parse(variantElement.getAttribute("data-product-variant"));
          if (!variantData) throw new Error("Variant data not found");
          return {
            id: variantData.id,
            handle: variantData.handle,
            title: variantData.title,
            available: variantData.available,
            tags: variantData.tags || [],
            variants: variantData.variants.map((v) => ({
              id: v.id,
              available: variantData.tags.includes('coming-soon') ? false : v.available,
              title: v.title,
              inventory_quantity: v.inventory_quantity,
              inventory_management: v.inventory_management,
            })),
          };
        } catch (error) {
          console.error("Error parsing variant JSON:", error);
          return null;
        }
      })
      .filter((variantObject) => variantObject !== null);

    elements.forEach((elem) => {
      const variantHandle = elem.getAttribute("data-product-handle");

      const matchedVariant = productVariants.find((variantObject) => variantObject.handle === variantHandle);
      if (matchedVariant && matchedVariant.tags.includes("coming-soon")) {
        let buttonAtc = elem.querySelector(".collection_modal_item__button");
        if (buttonAtc) buttonAtc.style.display = "none";

        let existingNotifyButton = elem.querySelector(".modal__button_notify-me");
        if (!existingNotifyButton) {
          let notifyButton = createNotifyButton(matchedVariant);
          elem.firstElementChild.appendChild(notifyButton);
        }
      }
    });
  }, 2500);
}

function createNotifyButton(variant) {
  const button = document.createElement("button");
  button.classList.add("modal__button_notify-me");
  let jsonProductVariant = JSON.stringify(variant).replaceAll("'","");
  button.innerHTML = `
    <a href="#" class="BIS_trigger" data-product-data='${jsonProductVariant}'>
      <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.5 12.6523L15.3477 14.5V15.4023H0.652344V14.5L2.5 12.6523V8.09766C2.5 6.66536 2.85807 5.41927 3.57422 4.35938C4.31901 3.29948 5.33594 2.61198 6.625 2.29688V1.65234C6.625 1.27995 6.75391 0.964844 7.01172 0.707031C7.26953 0.420573 7.59896 0.277344 8 0.277344C8.40104 0.277344 8.73047 0.420573 8.98828 0.707031C9.24609 0.964844 9.375 1.27995 9.375 1.65234V2.29688C10.6641 2.61198 11.6667 3.29948 12.3828 4.35938C13.1276 5.41927 13.5 6.66536 13.5 8.09766V12.6523ZM8 18.1523C7.48438 18.1523 7.04036 17.9805 6.66797 17.6367C6.32422 17.293 6.15234 16.8633 6.15234 16.3477H9.84766C9.84766 16.8346 9.66146 17.2643 9.28906 17.6367C8.91667 17.9805 8.48698 18.1523 8 18.1523Z" fill="white"/>
      </svg>
      Notify Me
    </a>`;
  return button;
}

function urlChange() {
  (function (history) {
    let pushState = history.pushState;
    let replaceState = history.replaceState;

    history.pushState = function (state, title, url) {
      if (typeof history.onpushstate == "function") {
        history.onpushstate({ state: state });
      }
      // Llamar al método original
      return pushState.apply(history, arguments);
    };

    history.replaceState = function (state, title, url) {
      if (typeof history.onreplacestate == "function") {
        history.onreplacestate({ state: state });
      }
      // Llamar al método original
      return replaceState.apply(history, arguments);
    };

    window.addEventListener("popstate", function (event) {
      renderButtonCommingSoon();
      renderButtonOpen();
    });
  })(window.history);
  
  window.history.onpushstate = window.history.onreplacestate = function (
    event
  ) {
    renderButtonCommingSoon();
    renderButtonOpen();
  };
}

function main() {
  urlChange();  
  renderButtonCommingSoon();
  renderButtonOpen();
  requestProductSection();
}

main();

document.setATC = main
